import { combineReducers } from "redux";
import auth from "./auth";
import users from "./users";
import usersLoading from "./usersLoading";
export default combineReducers({
  auth,
  users,
  usersLoading,
});
